module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/air-conditioner/air_conditioner.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/air-conditioner/air_conditioner.png
// module id = 508
// module chunks = 0